import { PUBLIC_BASE_URL } from "config";
import type { UserAvatar } from "./types";

// Полный URL собственного аватара (сервер отдаёт относительный путь)
// или null, если нужно показать плейсхолдер.
export const getAvatarUrl = (avatar: UserAvatar): string | null =>
  avatar.has_custom && avatar.url ? `${PUBLIC_BASE_URL}${avatar.url}` : null;
